import {addToFetchedWithContext} from 'modules/context/context-actions';
import {selectContextRawData} from 'modules/context/context-selector';
import {WIDGET_PAGE_ENTITY_NAME} from 'pages/widget-page/widget-page';
import {EEntityType} from 'shared/constants/entities';
import {showMessageFromResponse} from 'shared/utils';
import {createAction} from 'store/config/creators';
import {TAppState, TDispatch} from 'store/config/types';

import {fetchAllMetadata, fetchEntityMetadata} from './metadata-api';
import {EMetaActionType, MetadataActions} from './metadata-constants';
import {selectMetadata} from './metadata-selectors';
import {
    IEntityMeta, TFormDraftMetadataPayload,
    TMetadataResetPayload,
    TMetadataSetAllPayload,
    TMetadataSetPayload,
} from './metadata-types';
import {getActionByType} from './metadata-utils';

export const setAllMetadata = createAction<TMetadataSetAllPayload>(MetadataActions.SET_ALL_METADATA);
export const setMetadata = createAction<TMetadataSetPayload>(MetadataActions.SET_METADATA);
export const resetMetadata = createAction<TMetadataResetPayload>(MetadataActions.RESET_METADATA);
export const setFormDraftMetadata = createAction<TFormDraftMetadataPayload>(MetadataActions.SET_FORM_DRAFT_METADATA);

export const loadAllMetadata = () => async (dispatch: TDispatch) => {
    const response = await fetchAllMetadata();
    const data = response.data as IEntityMeta[];
    dispatch(setAllMetadata({metadata: data}));
};

export const loadMetadata = (
    entityName: string,
    entityType: EEntityType,
    reloadMeta?: boolean,
) => async (dispatch: TDispatch, getState: () => TAppState) => {
    const existingMetadata = selectMetadata(entityName, entityType)(getState());
    const contextFilterData = selectContextRawData(getState());

    let metadataResponse = null;
    const taxPeriodId = !existingMetadata?.useContext ? null : contextFilterData?.taxPeriodId || null;

    if (!reloadMeta && existingMetadata) return null;
    if (entityName === WIDGET_PAGE_ENTITY_NAME) return null;

    try {
        if (entityType !== EEntityType.CONTEXT_FILTER) {
            const {data, data: {actions}} = await fetchEntityMetadata(entityName, entityType, taxPeriodId);
            const metadata = {
                ...data,
                isFilterable: !!getActionByType(EMetaActionType.FILTER)(actions),
                isSearchable: !!getActionByType(EMetaActionType.SEARCH)(actions),
            };
            metadataResponse = metadata;
            dispatch(setMetadata({entityName, entityType, metadata}));

            if (taxPeriodId && existingMetadata?.useContext) {
                dispatch(addToFetchedWithContext(entityName));
            }
        }
    } catch (e: any) {
        console.error(e);
        showMessageFromResponse({response: e.response, isError: true});
    }

    return metadataResponse;
};
